import { Component, OnInit } from '@angular/core';
import { SideMenu } from '../../../common/menu.model';

@Component({
    selector: 'app-superadmin-sidebar',
    templateUrl: './sidebar.component.html',
    styleUrls: ['./sidebar.component.css']
})
export class SuperadminSidebarComponent implements OnInit {
    public sidemenu: SideMenu;

    constructor() {
        this.sidemenu = new SideMenu();
    }
    ngOnInit() {}
}



// WEBPACK FOOTER //
// ./src/app/pages/role-specific/superadmin/sidebar/sidebar.component.ts